document.documentElement.classList.remove('no-js');

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

function initCustomizer(root) {
  if (!root || root.dataset.customizerReady === 'true') return;
  root.dataset.customizerReady = 'true';

  const stage = root.querySelector('[data-customizer-stage]');
  const garmentPreview = root.querySelector('[data-garment-preview]');
  const artworkLayer = root.querySelector('[data-artwork-layer]');
  const artworkPreview = root.querySelector('[data-artwork-preview]');
  const placeholder = root.querySelector('[data-artwork-placeholder]');
  const artworkInput = root.querySelector('[data-artwork-input]');
  const error = root.querySelector('[data-artwork-error]');
  const scaleInput = root.querySelector('[data-artwork-scale]');
  const xInput = root.querySelector('[data-artwork-x]');
  const yInput = root.querySelector('[data-artwork-y]');
  const placement = root.querySelector('[data-placement]');
  const method = root.querySelector('[data-print-method]');
  const variant = root.querySelector('[data-customizer-variant]');
  const submit = root.querySelector('[data-customizer-submit]');
  const embroideryNote = root.querySelector('[data-embroidery-note]');
  const emailLink = root.querySelector('[data-email-summary]');
  let objectUrl = '';

  const syncEmail = () => {
    if (!emailLink) return;
    const valueFor = (selector) => root.querySelector(selector)?.value || 'Not selected';
    const colour = root.querySelector('[data-colour-property]')?.value || 'Black';
    const filename = artworkInput?.files?.[0]?.name || 'Not attached';
    const reference = root.querySelector('[data-customizer-reference]')?.value || '';
    const body = [
      'Hello Aflatoon Tees,',
      '',
      'I would like help with this custom tee:',
      `Reference: ${reference}`,
      `Garment: ${valueFor('[name="properties[Garment]"]')}`,
      `Colour: ${colour}`,
      `Size: ${valueFor('[name="properties[Size]"]')}`,
      `Quantity: ${valueFor('[name="quantity"]')}`,
      `Print method: ${valueFor('[name="properties[Print method]"]')}`,
      `Placement: ${valueFor('[name="properties[Placement]"]')}`,
      `Artwork file: ${filename}`,
      '',
      'I will attach the artwork file to this email.'
    ].join('\n');
    emailLink.href = `mailto:${root.dataset.supportEmail}?subject=${encodeURIComponent(`Custom tee enquiry ${reference}`)}&body=${encodeURIComponent(body)}`;
  };

  const syncArtwork = () => {
    if (!artworkLayer) return;
    const scale = Number(scaleInput?.value || 28);
    const x = Number(xInput?.value || 50);
    const y = Number(yInput?.value || 39);
    artworkLayer.style.width = `${scale}%`;
    artworkLayer.style.left = `${x}%`;
    artworkLayer.style.top = `${y}%`;
    root.querySelector('[data-scale-output]')?.replaceChildren(`${scale}%`);
    const scaleProperty = root.querySelector('[data-scale-property]');
    const xProperty = root.querySelector('[data-x-property]');
    const yProperty = root.querySelector('[data-y-property]');
    if (scaleProperty) scaleProperty.value = `${scale}%`;
    if (xProperty) xProperty.value = `${x}%`;
    if (yProperty) yProperty.value = `${y}%`;
    syncEmail();
  };

  root.querySelectorAll('[data-colour]').forEach((button) => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-colour]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (garmentPreview) {
        garmentPreview.src = button.dataset.shirtSrc;
        garmentPreview.alt = `${button.dataset.colour} T-shirt preview`;
      }
      const name = root.querySelector('[data-colour-name]');
      const property = root.querySelector('[data-colour-property]');
      if (name) name.textContent = button.dataset.colour;
      if (property) property.value = button.dataset.colour;
      syncEmail();
    });
  });

  artworkInput?.addEventListener('change', () => {
    const file = artworkInput.files?.[0];
    if (!file || !artworkPreview) {
      syncEmail();
      return;
    }
    const maxBytes = Number(root.dataset.maxFileMb || 20) * 1024 * 1024;
    if (file.size > maxBytes) {
      artworkInput.value = '';
      if (error) error.textContent = `Please choose a file smaller than ${root.dataset.maxFileMb || 20} MB.`;
      syncEmail();
      return;
    }
    if (error) error.textContent = '';
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = URL.createObjectURL(file);
    artworkPreview.src = objectUrl;
    artworkPreview.hidden = false;
    if (placeholder) placeholder.hidden = true;
    artworkPreview.onerror = () => {
      artworkPreview.hidden = true;
      if (placeholder) placeholder.hidden = false;
      if (error) error.textContent = 'This file can be ordered, but this browser cannot preview it. PNG, JPG or WebP gives the best live preview.';
    };
    syncEmail();
  });

  placement?.addEventListener('change', () => {
    const option = placement.options[placement.selectedIndex];
    if (xInput) xInput.value = option.dataset.x || 50;
    if (yInput) yInput.value = option.dataset.y || 39;
    if (scaleInput) scaleInput.value = option.dataset.scale || 28;
    syncArtwork();
  });

  [scaleInput, xInput, yInput].forEach((input) => input?.addEventListener('input', syncArtwork));

  if (stage && artworkLayer) {
    artworkLayer.addEventListener('pointerdown', (event) => {
      if (!artworkPreview || artworkPreview.hidden) return;
      artworkLayer.setPointerCapture(event.pointerId);
      artworkLayer.classList.add('is-dragging');
    });
    artworkLayer.addEventListener('pointermove', (event) => {
      if (!artworkLayer.hasPointerCapture(event.pointerId)) return;
      const rect = stage.getBoundingClientRect();
      if (xInput) xInput.value = clamp(Math.round(((event.clientX - rect.left) / rect.width) * 100), 25, 75);
      if (yInput) yInput.value = clamp(Math.round(((event.clientY - rect.top) / rect.height) * 100), 22, 68);
      syncArtwork();
    });
    const finishDrag = (event) => {
      if (artworkLayer.hasPointerCapture(event.pointerId)) artworkLayer.releasePointerCapture(event.pointerId);
      artworkLayer.classList.remove('is-dragging');
    };
    artworkLayer.addEventListener('pointerup', finishDrag);
    artworkLayer.addEventListener('pointercancel', finishDrag);
  }

  const syncMethod = () => {
    const isEmbroidery = method?.value === 'Embroidery quote';
    if (embroideryNote) embroideryNote.hidden = !isEmbroidery;
    if (submit) {
      submit.disabled = isEmbroidery;
      submit.textContent = isEmbroidery ? 'Request an embroidery quote below' : 'Add custom tee to cart';
    }
    syncEmail();
  };

  method?.addEventListener('change', syncMethod);
  variant?.addEventListener('change', () => {
    const price = root.querySelector('[data-customizer-price]');
    if (price) price.textContent = variant.options[variant.selectedIndex]?.dataset.price || '';
  });
  root.querySelectorAll('[data-summary-field], textarea').forEach((field) => field.addEventListener('change', syncEmail));

  const reference = root.querySelector('[data-customizer-reference]');
  if (reference) reference.value = `AT-${Date.now().toString(36).toUpperCase()}`;
  syncArtwork();
  syncMethod();
}

function initTheme(scope = document) {
  scope.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    if (button.dataset.ready === 'true') return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = menu.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  });

  scope.querySelectorAll('[data-variant-select]').forEach((select) => {
    if (select.dataset.ready === 'true') return;
    select.dataset.ready = 'true';
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const target = document.querySelector('[data-product-price]');
      if (target && option.dataset.price) target.textContent = option.dataset.price;
    });
  });

  scope.querySelectorAll('[data-carousel]').forEach((carousel) => {
    if (carousel.dataset.ready === 'true') return;
    carousel.dataset.ready = 'true';
    carousel.querySelectorAll('[data-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const track = carousel.querySelector('[data-track]');
        if (!track) return;
        const direction = button.dataset.scroll === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  });

  scope.querySelectorAll('[data-customizer]').forEach(initCustomizer);
}

document.addEventListener('DOMContentLoaded', () => initTheme());
document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
